import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "application-form" }
const _hoisted_2 = { class: "form-title" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  for: "englishName",
  class: "form-label"
}
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  for: "chineseName",
  class: "form-label"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  for: "email",
  class: "form-label"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  for: "phone",
  class: "form-label"
}
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  for: "address",
  class: "form-label"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  for: "remarks",
  class: "form-label"
}
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "form-actions" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.t('applicationForm')), 1),
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
      class: "form-container"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.t('englishName')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "englishName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.englishName) = $event)),
          class: "form-input",
          required: "",
          placeholder: _ctx.t('inputEnglishName')
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.formData.englishName]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t('chineseName')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "chineseName",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.chineseName) = $event)),
          class: "form-input",
          required: "",
          placeholder: _ctx.t('inputChineseName')
        }, null, 8, _hoisted_8), [
          [_vModelText, _ctx.formData.chineseName]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t('applicationEmail')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.email) = $event)),
          class: "form-input",
          required: "",
          placeholder: _ctx.t('inputEmail')
        }, null, 8, _hoisted_11), [
          [_vModelText, _ctx.formData.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t('phoneNumber')), 1),
        _withDirectives(_createElementVNode("input", {
          type: "tel",
          id: "phone",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.phone) = $event)),
          class: "form-input",
          required: "",
          placeholder: _ctx.t('inputPhone')
        }, null, 8, _hoisted_14), [
          [_vModelText, _ctx.formData.phone]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t('applicationAddress')), 1),
        _withDirectives(_createElementVNode("textarea", {
          id: "address",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.address) = $event)),
          class: "form-textarea",
          rows: "3",
          placeholder: _ctx.t('inputAddress')
        }, null, 8, _hoisted_17), [
          [_vModelText, _ctx.formData.address]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t('remarks')), 1),
        _withDirectives(_createElementVNode("textarea", {
          id: "remarks",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.remarks) = $event)),
          class: "form-textarea",
          rows: "4",
          placeholder: _ctx.t('inputRemarks')
        }, null, 8, _hoisted_20), [
          [_vModelText, _ctx.formData.remarks]
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          type: "submit",
          class: "submit-button",
          disabled: _ctx.submitting
        }, _toDisplayString(_ctx.submitting ? _ctx.t('submitting') : _ctx.t('submit')), 9, _hoisted_22),
        _createElementVNode("button", {
          type: "button",
          class: "cancel-button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _toDisplayString(_ctx.t('goBack')), 1)
      ])
    ], 32)
  ]))
}